export default __webpack_public_path__ + "63f8f959244fab8f28843592d4bfafc5.svg";